// Vollea web — Bottom Tab Bar
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { IoHome, IoTrophy, IoPodium, IoPersonCircle } from "react-icons/io5";
import { C } from "../lib/theme";

const TABS = [
  { key: "home", path: "/dashboard", label: "Home", Icon: IoHome, match: ["/dashboard"] },
  { key: "leagues", path: "/leagues", label: "Leagues", Icon: IoTrophy, match: ["/leagues"] },
  { key: "rankings", path: "/rankings", label: "Rankings", Icon: IoPodium, match: ["/rankings"] },
  { key: "profile", path: "/profile", label: "Profile", Icon: IoPersonCircle, match: ["/profile"] },
];

export default function BottomTabs({ badge = {} }) {
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname;

  return (
    <nav style={{
      position: "fixed", bottom: 0, left: "50%", transform: "translateX(-50%)", width: "100%", maxWidth: 480,
      background: "#0A0A0A", borderTop: `1px solid ${C.border}`, height: 64, display: "flex",
      paddingTop: 8, zIndex: 9999,
    }}>
      {TABS.map(({ key, path: p, label, Icon, match }) => {
        const on = match.some((m) => path === m || path.startsWith(m + "/"));
        const color = on ? C.lime : C.textDim;
        return (
          <button
            key={key}
            data-testid={`tab-${key}`}
            onClick={() => navigate(p)}
            style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", gap: 2, color, position: "relative" }}
          >
            <Icon size={24} color={color} />
            <span style={{ fontSize: 11, fontWeight: 600, color }}>{label}</span>
            {badge[key] > 0 && (
              <span style={{ position: "absolute", top: -2, right: "28%", background: C.lime, color: C.onLime, fontSize: 10, fontWeight: 700, borderRadius: 9, minWidth: 16, height: 16, display: "flex", alignItems: "center", justifyContent: "center", padding: "0 4px" }}>{badge[key]}</span>
            )}
          </button>
        );
      })}
    </nav>
  );
}
